export enum BreakpointHeightPx {
  Small = 500,
  Large = 700,
}
